import ListMixin from './listMixin';
import cloneDeep from 'lodash/cloneDeep';
import { userItemsPerListMixin } from '@/utils/vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewISAssetMgmtZones',
  mixins: [ListMixin, userItemsPerListMixin],
  data: function () {
    return {
      tooltips: {},
      tooltip: false,
      listPersistencePath: 'IsAssetMgmt.zones',
      fetchType: 'zone',
      tableOptions: {
        ...defaultTableOptions
      }
    };
  },
  computed: {
    searchCategories() {
      return [{
        value: 'title',
        text: this.$i18n_t('Common.help.titel')
      }, {
        value: 'id',
        text: `${this.$i18n_t('DigitalTwin.DigitalTwin.types.zone')} ${this.$i18n_t('Common.id')}`
      }, {
        value: 'floorDtwin.name',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor')
      }, {
        value: 'floorDtwin.number',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.map.floorLabel')
      }, {
        value: 'tag',
        text: this.$i18n_t('IS.AssetMgmt.list.category')
      }];
    },
    localizedTableOptions() {
      return {
        headers: [{
          text: this.$i18n_t('Common.id'),
          value: 'id',
          align: 'right',
          sortable: true
        }, {
          text: this.$i18n_t('Common.help.titel'),
          value: 'title',
          sortable: true
        }, {
          text: this.$i18n_t('IS.AssetMgmt.list.category'),
          value: 'category',
          sortable: false
        }, {
          text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor'),
          sortable: true,
          value: 'floorDtwin.title'
        }, {
          text: this.$i18n_t('DigitalTwin.DigitalTwin.types.building'),
          sortable: false,
          value: 'building.title'
        }, {
          text: this.$i18n_t('IS.AssetMgmt.list.assets'),
          sortable: false,
          value: 'trackables'
        }, {
          text: this.$i18n_t('Common.hierarchyLevel'),
          value: 'hierarchyLevel',
          sortable: true
        }, {
          text: this.$i18n_t('Common.tenant'),
          sortable: true,
          value: 'tenant.name'
        }, {}],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    },
    headerBG() {
      return './img/consumer.png';
    }
  },
  watch: {
    list() {
      this.tooltips = {};
      this.list.forEach(zone => {
        this.tooltips[zone.id] = false;
      });
    }
  },
  created() {
    this.tableOptions.page = defaultTableOptions.page;
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
    // this.fetchType = 'zone';
  },
  methods: {
    handleRowClick(item) {
      this.$router.push(`/digitaltwin-mgmt/${item.id}`);
    },
    toggleTrackablesTooltip(id) {
      if (this.tooltips[id] === true) {
        this.tooltips[id] = false;
      } else {
        this.tooltips[id] = true;
      }
      this.tooltips = cloneDeep(this.tooltips);
    },
    detailTableHeaderColClass(header, props) {
      let classes = [`text-${header.align || 'start'}`];
      if (header.sortable && ['title', 'id', 'floorDtwin.title'].indexOf(header.value) < 0) {
        classes.push('sortable');
      }
      const values = [header.value];
      if (props.options.sortBy && props.options.sortBy.length && values.indexOf(props.options.sortBy[0]) >= 0) {
        classes.push('active');
        if (props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0]) {
          classes.push('desc');
        } else {
          classes.push('asc');
        }
      }
      return classes.join(' ');
    },
    detailTableHeaderClasses(props) {
      const sortBy = props.options.sortBy && props.options.sortBy.length ? props.options.sortBy[0] : 'none';
      const sortDesc = props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0];
      return {
        text: {
          title: `header-item-sortable ${sortBy === 'title' ? 'header-active' : 'header-nonactive'}`,
          id: `header-item-sortable ${sortBy === 'id' ? 'header-active' : 'header-nonactive'}`,
          floorDtwinTitle: `header-item-sortable ${sortBy === 'floorDtwin.title' ? 'header-active' : 'header-nonactive'}`
        },
        icon: {
          title: sortBy === 'title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          id: sortBy === 'id' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          floorDtwinTitle: sortBy === 'floorDtwin.title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive'
        }
      };
    }
  }
};